import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Grid, Typography } from "@material-ui/core/";
import OptionCard from "../../../components/optionCard/OptionCard";
import { Link } from "react-router-dom";
import RequestService from "../../../services/RequestService";
import { AppThemeRequestProvider } from "../../../context/ThemeRequestContext";
import TmpSkeletonLeftPageCustom from "../../../components/tempo/TmpSkeletonLeftPageCustom/TmpSkeletonLeftPageCustom";
import ParameterService from "../../../services/ParameterService";


export default function PreHome() {

  const [showReRegistration, setShowReRegistration] = useState(false);
  const [loadingApi, setLoadingApi] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const useIsMounted = () => {
    const isMounted = React.useRef(false);
    React.useEffect(() => {
      setLoadingApi(true);
      isMounted.current = true;
      RequestService.getAllRequests().then(e => { });

      ParameterService.getParameter("SOLICITACAO_RECADASTRAMENTO_INICIADA").then(e => {
        if (e.value === "true") {
          setShowReRegistration(true);
        }
        setLoadingApi(false);
      });

      return () => {
        isMounted.current = false;
      };
    }, []);
    return isMounted;
  };

  useIsMounted();

  return (
    <AppThemeRequestProvider>
      <Grid container>
        {/* Coluna da Esquerda */}
        <Grid item xs={5}>
          <TmpSkeletonLeftPageCustom
            title={["Bem vindo ao <br /> Portal de <br /> Serviço de Apoio ao Médico"]}
            showImage={true}
            subTitle={" O Portal do SAM - Serviço de Apoio ao Médico é destinado aos profissionais que desejam fazer parte do corpo clínico do Sírio-Libanês e também para dar suporte as informações cadastrais dos profissionais."}
          />
        </Grid>
        {/* Coluna da Esquerda */}
        {/* Coluna da Direita */}
        <Grid item xs={7}>
          <Grid container spacing={4} style={{ display: "flex", justifyContent: "center" }} >
            <Grid item>
              <Typography style={{ fontSize: "1.5em", color: "#000", fontWeight: "400", fontFamily: "Inter", lineHeight: 1.3 }}>
                Escolha alguma das opções abaixo para continuar:
              </Typography>
            </Grid>
            <Grid item >
              <Box width={"550px"}>
                <Link to="/home" style={{ textDecoration: "none" }}>
                  <OptionCard
                    title="Criar uma solicitação"
                    subTitle="Ainda não sou cadastrado e desejo fazer parte do Sírio-Libanês, ou já solicitei um cadastro e desejo acompanhar."
                  />
                </Link>
              </Box>
            </Grid>
            {loadingApi ?
              <Grid container justifyContent="center" style={{ width: "85%" }} >
                <CircularProgress />
              </Grid>
              : null}
            {showReRegistration ?
              <Grid item >
                <Box width={"550px"}>
                  <Link to="/login" style={{ textDecoration: "none" }}>
                    <OptionCard
                      title="Recadastramento"
                      subTitle="Já sou cadastrado e desejo realizar a atualização das minhas informações cadastrais."
                    />
                  </Link>
                </Box>
              </Grid>
              : null}
          </Grid>
        </Grid>
        {/* Coluna da Direita */}
      </Grid>
    </AppThemeRequestProvider>
  );
}
